import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { submitSupportFormThunk } from "../../redux/features/supportFormSlice";
import { fetchSetting } from "../../redux/features/settingSlice";
import { useTranslation } from "react-i18next";

function Contact() {
  const { t } = useTranslation()
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const [description, setDescription] = useState("");
  const [message, setMessage] = useState(""); // State to store success or error message

  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.supportForm);
  // 

  useEffect(() => {
    dispatch(fetchSetting()); // This will trigger the API call
  }, [dispatch]);

  const { setting } = useSelector((state) => state.setting);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate email format
    if (!/\S+@\S+\.\S+/.test(email)) {
      setMessage("Please enter a valid email address");
      setTimeout(() => setMessage(""), 2000); // Clear the message after 2 seconds
      return;
    }

    // Prepare form data
    const formData = {
      name,
      email,
      reason,
      description,
    };

    // Dispatch thunk and handle state clearing after success
    dispatch(submitSupportFormThunk(formData))
      .unwrap() // Unwraps the thunk for handling resolved/rejected states
      .then(() => {
        // Clear form fields after successful submission
        setName("");
        setEmail("");
        setReason("");
        setDescription("");
        setMessage("Form submitted successfully!");
        setTimeout(() => setMessage(""), 3000); // Clear the message after 2 seconds
      })
      .catch((error) => {
        // Handle any error that occurs during the form submission
        setMessage(`${error}`);
        setTimeout(() => setMessage(""), 3000); // Clear the message after 2 seconds
      });
  };

  return (
    <>
      <section className="form-section py-5 main-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-4 col-sm-4 col-xs-12">
              <div className="location">
                {/* <div className="location-txt">
                  <h3>Registered Address:</h3>
                  <p>
                    {setting?.address}
                  </p>
                </div> */}
              </div>
              <div className="location">
                <div className="location-txt">
                  <h3>{`${t('Collaboration_Mail')}`}</h3>
                  <p>{setting?.email}</p>
                </div>
              </div>
              {/* <div className="location">
                <div className="location-txt">
                  <h3>Support phone:</h3>
                  <p>{setting?.phone}</p>
                </div>
              </div> */}
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <div className="signup-heading mb-20">
                <h3>{`${t('Request_A_CallBack')}`}</h3>
                <p>
                  {`${t('To_know_more')}`}
                </p>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="form-div row">
                  <div className="col-md-6 col-sm-6 col-xs-12 mb-20">
                    <div className="form-group has-float-label">
                      <input
                        type="text"
                        id="txtName"
                        className="form-control"
                        placeholder={`${t('Enter_Your_Name_Here')}`}
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-12 mb-20">
                    <div className="form-group has-float-label">
                      <input
                        type="email"
                        id="email"
                        className="form-control"
                        placeholder={`${t('Enter_Your_Email_Here')}`}
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-12 col-xs-12 mb-20">
                    <div className="form-group">
                      <select
                        type="select"
                        className="form-control bg-white"
                        id="subject"
                        placeholder="Subject"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                      >
                        <option value="">{`${t('Select_a_reason')}`}</option>
                        <option value="Payment failure">{`${t('Payment_failure')}`}</option>
                        <option value="App Error">{`${t('App_Error')}`}</option>
                        <option value="Web Error">{`${t('Web_Error')}`}</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-12 col-xs-12 mb-20">
                    <div className="form-group has-float-label">
                      <textarea
                        rows="2"
                        cols="20"
                        id="message"
                        className="form-control"
                        placeholder={t("Message")}
                        required
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-12 col-xs-12 mb-20">
                    <div className="submit-btn">
                      <button
                        type="submit"
                        id="btn_verify"
                        className="theme-btn style-one"
                      >
                        {status === `${t("loading")}` ? `${t("Submitting")}` : `${t("Submit")}`}
                      </button>
                    </div>
                    {message && (
                      <div
                        style={{
                          marginTop: "10px",
                          fontWeight: 600,
                          color: message.includes("successfully")
                            ? "green"
                            : "red",
                        }}
                      >
                        {message}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div >
      </section >
    </>
  );
}

export default Contact;
